import type { Department } from './types';

export const mockDepartments: Department[] = [
  {
    id: 1,
    name: '技术部',
    leader: '张三',
    description: '负责系统开发、运维、技术支持等工作',
    userCount: 15,
    createdAt: '2024-01-10 09:00:00',
  },
  {
    id: 2,
    name: '运营部',
    leader: '李四',
    description: '负责用户运营、活动策划、数据分析等工作',
    userCount: 12,
    createdAt: '2024-01-10 09:15:00',
  },
  {
    id: 3,
    name: '商品部',
    leader: '王五',
    description: '负责商品管理、定价策略、库存管理等工作',
    userCount: 8,
    createdAt: '2024-01-10 09:30:00',
  },
  {
    id: 4,
    name: '客服部',
    leader: '赵六',
    description: '负责客户咨询、售后服务、投诉处理等工作',
    userCount: 20,
    createdAt: '2024-01-10 09:45:00',
  },
  {
    id: 5,
    name: '财务部',
    leader: '孙七',
    description: '负责财务管理、账单核对、资金结算等工作',
    userCount: 6,
    createdAt: '2024-01-10 10:00:00',
  },
  {
    id: 6,
    name: '人事部',
    leader: '周八',
    description: '负责人员招聘、培训、绩效考核等工作',
    userCount: 5,
    createdAt: '2024-01-10 10:15:00',
  },
  {
    id: 7,
    name: '市场部',
    leader: '吴九',
    description: '负责市场推广、品牌建设、渠道拓展等工作',
    userCount: 10,
    createdAt: '2024-02-01 14:20:00',
  },
  {
    id: 8,
    name: '产品部',
    leader: '郑十',
    description: '负责产品规划、需求分析、功能设计等工作',
    userCount: 9,
    createdAt: '2024-02-15 11:30:00',
  },
];
